// extracted by mini-css-extract-plugin
export default {"Image":"GoodHands_Image__IlVxv"};